import { useState, useEffect } from "react";
import axios from "axios";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  TextField,
  Button,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveIcon from "@mui/icons-material/Save";

import ResponsiveAppBar from "../ResponsiveAppBar"

import * as constants from "../constants.js"

const ComputationQueueManager = () => {
  const [queue, setQueue] = useState([]);

  useEffect(() => {
    fetchQueue();
  }, []);

  const fetchQueue = async () => {
    try {
      const response = await axios.create({
          withCredentials: true,
      }).get("//" + constants.BASE_URL + "/getComputationQueue");
      setQueue(response.data);
    } catch (error) {
      console.error("Error fetching parameters:", error);
    }
  };


  const updatePriority = async (id, newPriority) => {
    alert("Not implemented: Updating priority to " + newPriority);
  };

  const deleteEntry = async (id) => {
    try {
      const resp = await axios.create({
          withCredentials: true,
      }).post("//" + constants.BASE_URL + "/deleteFromQueue", {
          id: id
      });
      fetchQueue();
    } catch (error) {
        alert("Error deleting entry: " + error);
    }
  };

  const restartQueue = async () => {
    try {
      const resp = await axios.create({
          withCredentials: true,
      }).post("//" + constants.BASE_URL + "/restartQueue");
      alert(resp.data.success || resp.data.message);
      fetchQueue();
    } catch (error) {
      alert("Fehler beim Neustart der Queue: " + error);
    }
  };

  return (
    <div className="home">
        <ResponsiveAppBar />
        <div className="body-content">
    <Button variant="contained" color="warning" onClick={restartQueue} sx={{ mb: 2 }}>
      Queue neu starten
    </Button>
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>Region</TableCell>
            <TableCell>Szenario</TableCell>
            <TableCell>Algorithmus</TableCell>
            <TableCell>Benutzer</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Priority</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {queue.map((entry) => (
            <TableRow key={entry.id}>
              <TableCell>{entry.id}</TableCell>
              <TableCell>{entry.region_name}</TableCell>
              <TableCell>{entry.scenario_name}</TableCell>
              <TableCell>{entry.algorithm}</TableCell>
              <TableCell>{entry.user_email}</TableCell>
              <TableCell>{entry.status}</TableCell>
              <TableCell>
                <TextField
                  type="number"
                  size="small"
                  value={entry.priority}
                  onChange={(e) => {
                    const newPriority = parseFloat(e.target.value);
                    setQueue((prevQueue) =>
                      prevQueue.map((item) =>
                        item.id === entry.id ? { ...item, priority: newPriority } : item
                      )
                    );
                  }}
                />
                <IconButton onClick={() => updatePriority(entry.id, entry.priority)} size="small">
                  <SaveIcon />
                </IconButton>
              </TableCell>
              <TableCell>
                <IconButton onClick={() => deleteEntry(entry.id)} size="small" color="error">
                  <DeleteIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    </div>
    </div>
  );
};

export default ComputationQueueManager;
